//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commentsFormItem from '@/components/art/CommentsFormItem.vue';
import CommentsForm from '@/components/art/CommentsForm.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "CommentsBlockComponent",

  components: { commentsFormItem, CommentsForm },

  props: {
    comments: {
      type: Array,
      default: () => []
    },
    objectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: this.comments,
      submitting: false,
      closeForms: false,
      sortByNew: true,
      sliceCount: 7
    };
  },
  computed: {
    calcTotalCountComments() {
      return this.data.reduce((acc, comment) => {
        return acc + comment.total
      }, 0);
    },
    sortedComments() {
      return this.data.slice().sort((a, b) => {
        if (this.sortByNew) {
          return Date.parse(b.node.created_at) - Date.parse(a.node.created_at)
        } else {
          return Date.parse(a.node.created_at) - Date.parse(b.node.created_at)
        }
      })
    },
    limitedComments() {
      if (this.calcTotalCountComments > 7) {
        // Если общее кол-во комментов всех уровней больше 7, то вскрываем первые 7 комментов начиная с верхнего уровня
        if (this.sortedComments.length >= 7) {
          // Если комментариев 1 уровня больше 7, то вскрываем второв уровень самого верхнего коммента
          for (const item of this.sortedComments) {
            if (item.items.length > 0) {
              item.expanded = true;
              break;
            }
          }
        } else {
          // Если комментов 1 уровня меньше или равно 7, то мы показываем 7 комментов любых уровней, начиная с вверхнего уровня
          const queue = [...this.sortedComments];

          const limitedComments = [];
          let expandedCount = this.sortedComments.length;
          let firstItemExpanded = false

          while (queue.length > 0) {
            const comment = queue.shift();

            if (expandedCount < 7) {
              comment.expanded = true;
              expandedCount += comment.items.length;
            } else {
              comment.expanded = false;
            }

            limitedComments.push(comment);

            if (comment.items && comment.items.length > 0) {
              queue.push(...comment.items);
            }
            if (!firstItemExpanded) {
              if (comment.level === 2) {
                firstItemExpanded = true
              }
            }
          }
        }
      }
      // else иначе включается логика calcTotalCountComments < 7, то есть все комментарии вскрываются

      return this.sortedComments.slice(0, this.sliceCount);
    }
  },
  watch: {
    comments: {
      handler(newVal) {
        this.data = newVal
      },
      deep: true
    }
  },
  methods: {
    async submitComment(val) {
      if (!val) {
        return;
      }

      this.submitting = true;

      const newComment = {
        obj_id: this.objectId,
        obj_cls: 'materials',
        is_deleted: false,
        text: val,
      }

      await this.$axios.post(`${process.env.BASE_URL_V2}/admin/comments/`, newComment)
        .then(() => {
          const newObject = {
            items: [],
            total: 1,
            node: {
              id: uuidv4(),
              parent: null,
              created_at: new Date(new Date().getTime() + new Date().getTimezoneOffset() * 60000),
              is_deleted: false,
              text: val,
              user: this.$auth.user.id,
              user_annotated: {
                id: this.$auth.user.id,
                username: this.$auth.user.profile.nickname ?? this.$auth.user.username,
                profile: {
                  icon: this.$auth.user.profile.icon,
                  nickname: this.$auth.user.profile.nickname
                }
              }
            }
          }

          if (this.sortByNew) {
            this.data.unshift(newObject)
          } else {
            this.data.push(newObject)
          }

          this.value = ''
        })
        .finally(() => {
          this.submitting = false
        })
    },
    closeRestForms() {
      this.closeForms = !this.closeForms
    },
    toggleSort() {
      this.sortByNew = !this.sortByNew
    },
    addedNewComment(comment) {
      comment.total++
    },
    showMore() {
      if (this.sortedComments.length > this.sliceCount) {
        this.sliceCount += 7
      }
    }
  },
}
